type FluctTagParams = {
  groupId: string;
  unitName: string;
  unitId: string;
  ppid?: string;
};

type FluctSetConfig = {
  dlvParams?: {
    ppid?: string;
  };
};

export const buildFluctTag = ({
  groupId,
  unitName,
  unitId,
  ppid
}: FluctTagParams): string => {
  const setConfig: FluctSetConfig = buildSetConfig(ppid);
  return `
      var fluctAdScript = fluctAdScript || {};
      fluctAdScript.cmd = fluctAdScript.cmd || [];
      fluctAdScript.cmd.push(function (cmd) {
        ${buildSetConfigScript(setConfig)}
        cmd.setGamTargetingMap('%%PATTERN:TARGETINGMAP%%');
        cmd.requestAdByGroup("${groupId}")
          .display(".${unitName}", "${unitId}");
      });
    `;
};

const buildSetConfig = (ppid?: string): FluctSetConfig => {
  // 他の項目が出てきたら、下記に追加していく
  const dlvParams = {
    ...(ppid && { ppid })
  };

  return {
    ...(Object.keys(dlvParams).length > 0 && { dlvParams })
  };
};

const buildSetConfigScript = (config: FluctSetConfig): string => {
  if (!isValidSetConfig(config)) {
    return '';
  }

  return `cmd.setConfig(${JSON.stringify(config)});`;
};

const isValidSetConfig = (config: FluctSetConfig): boolean => {
  return Object.keys(config.dlvParams ?? {}).length > 0;
};
